import React, { useEffect, useState, useContext } from "react";
import Chart from "react-apexcharts";
import { ApexOptions } from "apexcharts";
import { DashboardContext } from "../../../../../contexts/Dashboard/DashboardContext";
import HeaderComponent from "../../../../HeaderComponent";
import { useParams } from "react-router-dom";
import { Documents } from ".";
import LoadingGraphics from "../../../../Loading/LoadingGraphics";

export const ChartBar = ({ data }: Documents) => {
  const {
    getSizesComponent,
    setFontSize,
    componentProperty,
    generateRedirectUrl
  } = useContext(DashboardContext);
  const [completeRequisition, setCompleteRequisition] = useState(false);
  const [heightChart, setHeightChart] = useState(380);
  const [widthChart, setWidthChart] = useState(300);
  const [dataChart, setDataChart] = useState<number[][]>([[], [], [], [], []]);
  const [total, setTotal] = useState<number>(0);
  const { mode } = useParams();

  const [options, setOptions] = useState<ApexOptions | null>(null);
  const [series, setSeries] = useState<{ data: number[] }[] | null>(null);

  useEffect(() => {
    const sizes = getSizesComponent({ id: "chart-region-collects-documents" });
    if (sizes.width < 345) {
      setFontSize({
        id: "chart-region-collects-documents",
        width: sizes.width,
      });
    }
    setWidthChart(sizes.width);
  }, [
    parseInt(
      (
        window.document.querySelector(`#chart-region-collects-documents`)
          ?.parentNode as HTMLElement
      ).style.width.slice(0, -2)
    ),
  ]);

  useEffect(() => {
    const sizes = getSizesComponent({ id: "chart-region-collects-documents" });
    if (dataChart[0] && dataChart[0].length > 0) {
      if (dataChart[0].length <= 2 || sizes.height > dataChart[0].length * 183) {
        setHeightChart(sizes.height - 40);
      } else {
        setHeightChart(dataChart[0].length * 180);
      }
    } else {
      setHeightChart(sizes.height - 40);
    }
  }, [
    parseInt(
      (
        window.document.querySelector(`#chart-region-collects-documents`)
          ?.parentNode as HTMLElement
      ).style.height.slice(0, -2)
    ),
    dataChart,
  ]);

  useEffect(() => {
    const cldataChart: number[][] = [[], [], [], [], [], []],
      regionQtd: number[] = [],
      clRegion: string[] = [];
    let y = 0,
      clQtd = 0;

    const sums: { [key: string]: number } = data.collects.reduce((accumulator, item) => {
      const { region, qtd } = item;
      accumulator[region] = (accumulator[region] || 0) + parseInt(qtd.toString());
      return accumulator;
    }, {} as { [key: string]: number });

    const result = Object.keys(sums).map(region => ({
      region: region !== 'null' ? region : null,
      qtd: sums[region],
    }));
    result.sort((a, b) => b.qtd - a.qtd);
    
    for (const item of result) {
      cldataChart[0][y] = 0;
      regionQtd.push(item.qtd)
      const notStarted =
      data.collects.find(obj => item.region === obj.region && obj.status === "Não iniciada");
      cldataChart[1][y] = notStarted?.qtd ? parseInt(notStarted.qtd.toString()) : 0;
      const inTransit =
      data.collects.find(obj => item.region === obj.region && obj.status === "Em trânsito");
      cldataChart[2][y] = inTransit?.qtd ? parseInt(inTransit.qtd.toString()) : 0;
      const arrived =
      data.collects.find(obj => item.region === obj.region && obj.status === "Chegou");
      cldataChart[3][y] = arrived?.qtd ? parseInt(arrived.qtd.toString()) : 0;
      const finished =
      data.collects.find(obj => item.region === obj.region && obj.status === "Finalizada");
      cldataChart[4][y] = finished?.qtd ? parseInt(finished.qtd.toString()) : 0;
      clRegion.push(item.region !== null ? item.region : 'null',);
      clQtd = +clQtd + +item.qtd;
      y++;
    }
    const highestNumber = cldataChart.reduce((highest, row) => {
      const maxInRow = row.reduce((max, num) => (num > max ? num : max), 0);
      return maxInRow > highest ? maxInRow : highest;
    }, 0);
    setTotal(clQtd);
    loadDataChart(cldataChart, clRegion, highestNumber, regionQtd);
  }, [data]);

  const loadDataChart = async (
    cldataChart: number[][],
    clRegion: string[],
    highestNumber: number,
    regionQtd: number[]
  ) => {
    setDataChart(cldataChart);
    const seriesArray: { data: number[] }[] = [
      {
        data: cldataChart[0],
      },
      {
        data: cldataChart[1],
      },
      {
        data: cldataChart[2],
      },
      {
        data: cldataChart[3],
      },
      {
        data: cldataChart[4],
      },
    ];
    setSeries(seriesArray);
    loadOptions(cldataChart, clRegion, highestNumber, regionQtd);
  };

  async function loadOptions(
    dataChart: number[][],
    labelsGroups: string[],
    highestNumber: number,
    regionQtd: number[]
  ) {
    setOptions({
      chart: {
        animations: {
          dynamicAnimation: {
            enabled: true,
            speed: 350,
          },
          enabled: false,
        },
        type: "bar",
        toolbar: {
          show: false,
        },
        events: {
          dataPointSelection: async (event, chartContext, config) => {
            let status = "";
            switch (config.seriesIndex) {
              case 0:
                break;
              case 1:
                status = "0,7,12,15,20";
                break;
              case 2:
                status = "1,5,18";
                break;
              case 3:
                status = "2,10,11";
                break;
              case 4:
                status = "3,4,6,8,9,17";
            }
            if (
              mode === "view" &&
              componentProperty({
                id: "chartRegionCollectsDocuments",
                property: "redirect",
              })
            ) {
              window.open(
                await generateRedirectUrl("chartRegionCollectsDocuments", {
                  redirectTowerToIndex: true,
                  date: true,
                  dueRouteDate: true,
                  route_stop_type: 'C',
                  status_stop_id: status,
                  region: labelsGroups[config.dataPointIndex]
                }),
                "_blank"
              );
            }
          },
        },
      },
      plotOptions: {
        bar: {
          barHeight: "80%",
          horizontal: true,
          dataLabels: { position: "bottom" },
        },
      },

      dataLabels: {
        enabled: true,
        textAnchor: "start",
        formatter: function (val, opt) {
          switch (opt.seriesIndex) {
            case 0:
              return labelsGroups[opt.dataPointIndex] + " : " + regionQtd[opt.dataPointIndex];
            case 1:
              return "Não iniciada : " + val;
            case 2:
              return "Em trânsito : " + val;
            case 3:
              return "Chegou : " + val;
            case 4:
              return "Finalizada : " + val;
          }
          return "";
        },
      },
      responsive: [
        {
          breakpoint: 480,
          options: {
            legend: { position: "bottom" },
          },
        },
      ],
      colors: ["#B1BCBE", "#B1BCBE", "#FFF49C", "#8FD3FF", "#85DE77"],
      yaxis: {
        labels: {
          show: false,
        },
      },
      xaxis: {
        max: highestNumber,
        categories: labelsGroups,
        range: 7,
      },
      grid: {
        xaxis: {
          lines: {
            show: false,
          },
        },
        yaxis: {
          lines: {
            show: false,
          },
        },
      },
      tooltip: { enabled: false },
      legend: { show: false },
    });
    setCompleteRequisition(true);
  }

  return completeRequisition && series && options ? (
    <>
      <div className="h100 w100">
        <HeaderComponent
          title={`Andamento por região: Você tem ${total} coletas hoje`}
          clickable={componentProperty({
            id: "chartRegionCollectsDocuments",
            property: "redirect",
          })}
          id="chart-region-collects-documents"
          width={widthChart}
        />

        <div
          id={
            dataChart &&
            (dataChart[0].length <= 2 ||
              getSizesComponent({ id: "chart-region-collects-documents" })
                .height >
                dataChart[0].length * 183)
              ? "fixedBox"
              : "scrollBox"
          }
        >
          <div id="chart">
            <Chart
              type="bar"
              options={options}
              series={series}
              height={heightChart}
              width={widthChart}
            />
          </div>
        </div>
      </div>
    </>
  ) : (
    <LoadingGraphics />
  );
};
